import React, { useState } from "react"
import * as styles from "./link-group.module.scss"
import { Link } from "gatsby"
import { useLink } from "../hooks/"
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa"
import { FaXTwitter } from "react-icons/fa6"

type Props = {
  item: {
    title: string
    sections: NavProps[]
  }
  homeLocation: boolean
  scrollTo: (id: string) => void
}

type NavProps = {
  title: string
  target?: {
    slug: string
    title: string
  }
  slug?: string
  image?: {
    gatsbyImageData: any
  }
}

const LinkGroup = ({ item, homeLocation, scrollTo }: Props) => {
  const [show, setShow] = useState(false)
  const { title, sections } = item

  return (
    <div onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <p className={styles.title}>{title}</p>
      <ul>
        {sections?.map((nav, id) => {
          const linkSlug = nav.target?.slug || nav.slug
          const { title } = nav

          return (
            <li key={id} className={styles.subNavLink}>
              {title === "Facebook" ? (
                <a>
                  {" "}
                  <FaFacebook />{" "}
                </a>
              ) : title === "Instagram" ? (
                <FaInstagram />
              ) : title === "X" ? (
                <FaXTwitter />
              ) : title === "LinkedIn" ? (
                <FaLinkedin />
              ) : title === "YouTube" ? (
                <FaYoutube />
              ) : null}

              {linkSlug && linkSlug.startsWith("http") ? (
                <a href={linkSlug} target="_blank" rel="noopener noreferrer">
                  {nav.title}
                </a>
              ) : linkSlug && linkSlug.includes("#") && homeLocation ? (
                <a
                  href={`#${linkSlug.replace("#", "")}`}
                  onClick={() => scrollTo(linkSlug.replace("#", ""))}
                >
                  {nav.title}
                </a>
              ) : (
                <Link to={`/${useLink(linkSlug)}`}>{nav.title}</Link>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default LinkGroup
